import { Helpers } from '@bode-canada/core';
import { QueryParams } from '@/constants/QueryParams';
import { SearchAddressControlValueProps, SearchFormControlName } from '../enums';
import { SEARCH_DEFAULT_VALUES } from '../constants';

export default class SearchQueryMapper {
  static mapFromQueries(queries) {
    return Helpers.ObjectHelper.removeEmptyProperties({
      [SearchFormControlName.Address]: {
        [SearchAddressControlValueProps.Address]: queries[QueryParams.Address],
        [SearchAddressControlValueProps.AddressId]: queries[QueryParams.AddressId],
      },
    });
  }

  static mapToQueries(formData) {
    const addressControlValue = formData[SearchFormControlName.Address]
      || SEARCH_DEFAULT_VALUES[SearchFormControlName.Address];

    return Helpers.ObjectHelper.removeEmptyProperties({
      [QueryParams.Address]: addressControlValue[SearchAddressControlValueProps.Address],
      [QueryParams.AddressId]: addressControlValue[SearchAddressControlValueProps.AddressId],
    });
  }
}
